// https://github.com/vercel/next.js/discussions/19065
import NextImage, { ImageProps } from 'next/legacy/image'
import React from 'react'

export type customLoaderProps = {
    src: string
}

// opt-out of image optimization, no-op
const customLoader = ({ src }: customLoaderProps): string => {
    return src
}

const Image = (props: ImageProps): React.ReactElement => {
    return <NextImage {...props} loader={customLoader} unoptimized />
}

export default Image
